import React, {Fragment} from "react";
import connect from "react-redux/es/connect/connect";
import {showModal} from "../../actions";
import createEditor, {referenceActionData} from "../form/ComponentEditor";
import TransactionPaymentForm from "./forms/TransactionPaymentForm.js";
import TransactionPaymentList from "./lists/TransactionPaymentList";
import Box from "../layout/Box";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class TransactionPaymentEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header="Fizetések"
            >
                <TransactionPaymentList ref={(el) => this.list = el} {...this.props} loadForm={(this.props.presets || {}).transaction ? null : this.loadForm} />
            </List>
            {this.props.values[this.props.componentConfig.idfield] && <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Fizetések"
            >
                <TransactionPaymentForm {...this.props} />
            </Editor>}
        </Fragment>;
    }

}

export default connect((state) => {
    return {
        till: state.app.till
    };
},{showModal})(createEditor({
    componentName: "TransactionPayment",
    editor: "RealTransactionPayment",
    WrappedComponent: TransactionPaymentEditor,
    props: {
        //view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
}));